import { render, staticRenderFns } from "./text-highlight-right.vue?vue&type=template&id=19ee5319&scoped=true&"
var script = {}
import style0 from "./text-highlight-right.vue?vue&type=style&index=0&id=19ee5319&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ee5319",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ee5319')) {
      api.createRecord('19ee5319', component.options)
    } else {
      api.reload('19ee5319', component.options)
    }
    module.hot.accept("./text-highlight-right.vue?vue&type=template&id=19ee5319&scoped=true&", function () {
      api.rerender('19ee5319', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-highlight-right.vue"
export default component.exports